// import request from '@/utils/request'
import {service as request} from '@/utils/request'


// 登录,注册重定向
export function loginRedirect(data) {
  return request({
    url: 'jdh-portal-service/portal/common/getIndexRedirectUrl',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js